import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IErforderlichesDokumentsResponse } from 'fa-kt.types';
import { PostErforderlichesDokumentCommandService } from '../commands';
import { ErforderlichesDokumentsService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class ErforderlichesDokumentsPageResolver implements Resolve<IErforderlichesDokumentsResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private erforderlichesDokuments: ErforderlichesDokumentsService,
    private postErforderlichesDokument: PostErforderlichesDokumentCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IErforderlichesDokumentsResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [erforderlichesDokuments] = await Promise.all([this.erforderlichesDokuments.request({}).catch(log), this.postErforderlichesDokument.prepare(true).catch(log)]);
    this.loading.resolved();
    return erforderlichesDokuments;
  }
}
